import { useCallback } from 'react'

import { FixedBanner, TextLink } from '@circlefin/components'
import { useModal } from '@circlefin/modal-router'
import useTranslation from 'next-translate/useTranslation'

import {
  getAddAddressModalPathByStatus,
  PENDING_ADDRESS_STATES,
} from '../../utils'

import type {
  BlockchainAddressStatus,
  BlockchainRecipientAddressOwner,
} from '@shared/graphql'

export interface PendingAddressDetailBannerProps {
  /*
   * Address id.
   */
  id: string
  /*
   * Address status.
   */
  status: BlockchainAddressStatus
  /*
   * Address owner.
   */
  owner: BlockchainRecipientAddressOwner
}

export const PendingAddressDetailBanner: React.FC<
  PendingAddressDetailBannerProps
> = ({ id, status, owner }) => {
  const { t } = useTranslation('address-book/components')
  const modal = useModal()

  const handleClick = useCallback(() => {
    modal.router.push({
      pathname: getAddAddressModalPathByStatus(status),
      query: {
        addressId: id,
        owner: owner,
      },
    })
  }, [id, modal.router, owner, status])

  return (
    <FixedBanner
      level="site"
      status="warning"
      visible={PENDING_ADDRESS_STATES.includes(status)}
    >
      <FixedBanner.Title>{t(`detailBanner.title.${status}`)}</FixedBanner.Title>
      <FixedBanner.Description>
        {t(`detailBanner.description.${status}`)}
        <TextLink onClick={handleClick} size="sm" variant="primary">
          {t(`detailBanner.link.${status}`)}
        </TextLink>
      </FixedBanner.Description>
    </FixedBanner>
  )
}
